import React, { useState } from 'react';
import L from 'leaflet';

import Geocoder from '~/core/scripts/components/Geocoder';
import BasisMap from '~/core/scripts/map-components/BasisMap';
import TrueSize from './TrueSize';

const basemapAttribution =
  'Map: <a href="https://www.maptiler.com/license/maps/" target="_blank">© MapTiler</a> <a href="https://www.openstreetmap.org/copyright" target="_blank">© OpenStreetMap contributors</a>';

const corner1 = L.latLng(-90, -200);
const corner2 = L.latLng(90, 200);
const bounds = L.latLngBounds(corner1, corner2);

export default () => {
  const [geocoderLatLng, setGeocoderLatLng] = useState(null);
  const onSelect = res => {
    if (!res) {
      return null;
    }

    const {
      latitude,
      longitude
    } = res.response.view[0].result[0].location.displayPosition;

    setGeocoderLatLng([latitude, longitude]);
  };

  return (
    <div className="truesize-wrapper map-widget">
      <div className="truesize-map map-wrapper">

        <BasisMap
          center={ARTICLE_CONFIG.center}
          zoom={6}
          minZoom={2}
          showBasemap
          basemapUrl="https://api.maptiler.com/maps/2b553cfb-ca68-4ae9-a27e-50da88a0043f/256/{z}/{x}/{y}@2x.png?key=68ErAz6zqgdV9jEjhpuz"
          basemapAttribution={basemapAttribution}
          geocoderLatLng={geocoderLatLng}
          zoomAfterGeocode={6}
          maxBounds={bounds}
        >
          <TrueSize center={geocoderLatLng} />
        </BasisMap>
        </div>

        <Geocoder
          onSelect={onSelect}
          presets={[
            { name: 'Iceland', locationId: 'NT_8uYxUj.NFlnEEMSZwIuzeA' },
            { name: 'Berlin', locationId: 'NT_DKX2wfaWICS7JyfHmCOJhB' },
            { name: 'NYC', locationId: 'NT_YpQcXqbaOb.I4m5EW8BHEC' },
            { name: 'London', locationId: 'NT_AP3PoLHpeA15ngMJxal4hC' }
          ]}
          presetsTitle="Examples:"
        />
    </div>
  );
};
